export const ENTERTAINMENT_EXPENSES_RECEIPT_MIN_SUM = 250
